const countries: {
	code: string;
	label: string;
	phone: string;
	icon: string;
	highlight?: boolean;
}[] = [
	{
		code: "CO",
		label: "Colombia",
		phone: "57",
		highlight: true,
		icon: "https://cdn1.infocasas.com.uy/web/CO.png",
	},
	{
		code: "US",
		label: "Estados Unidos",
		phone: "1",
		icon: "https://cdn1.infocasas.com.uy/web/US.png",
	},
	{
		code: "AR",
		label: "Argentina",
		phone: "54",
		icon: "https://cdn1.infocasas.com.uy/web/AR.png",
	},
	{
		code: "BO",
		label: "Bolivia",
		phone: "591",
		icon: "https://cdn1.infocasas.com.uy/web/BO.png",
	},
	{ code: "BR", label: "Brasil", phone: "55", icon: "https://cdn1.infocasas.com.uy/web/BR.png" },
	{ code: "CL", label: "Chile", phone: "56", icon: "https://cdn1.infocasas.com.uy/web/CL.png" },
	{
		code: "EC",
		label: "Ecuador",
		phone: "593",
		icon: "https://cdn1.infocasas.com.uy/web/EC.png",
	},
	{ code: "GY", label: "Guyana", phone: "592", icon: "https://cdn1.infocasas.com.uy/web/GY.png" },
	{
		code: "PY",
		label: "Paraguay",
		phone: "595",
		icon: "https://cdn1.infocasas.com.uy/web/PY.png",
	},
	{ code: "PE", label: "Perú", phone: "51", icon: "https://cdn1.infocasas.com.uy/web/PE.png" },
	{
		code: "UY",
		label: "Uruguay",
		phone: "598",
		icon: "https://cdn1.infocasas.com.uy/web/UY.png",
	},
	{
		code: "VE",
		label: "Venezuela",
		phone: "58",
		icon: "https://cdn1.infocasas.com.uy/web/VE.png",
	},
	{
		code: "AF",
		label: "Afganistán",
		phone: "93",
		icon: "https://cdn1.infocasas.com.uy/web/AF.png",
	},
	{
		code: "AL",
		label: "Albania",
		phone: "355",
		icon: "https://cdn1.infocasas.com.uy/web/AL.png",
	},
	{
		code: "DE",
		label: "Alemania",
		phone: "49",
		icon: "https://cdn1.infocasas.com.uy/web/DE.png",
	},
	{
		code: "AD",
		label: "Andorra",
		phone: "376",
		icon: "https://cdn1.infocasas.com.uy/web/AD.png",
	},
	{ code: "AO", label: "Angola", phone: "244", icon: "https://cdn1.infocasas.com.uy/web/AO.png" },
	{
		code: "AI",
		label: "Anguila",
		phone: "1264",
		icon: "https://cdn1.infocasas.com.uy/web/AI.png",
	},
	{
		code: "AG",
		label: "Antigua y Barbuda",
		phone: "1268",
		icon: "https://cdn1.infocasas.com.uy/web/AG.png",
	},
	{
		code: "SA",
		label: "Arabia Saudita",
		phone: "966",
		icon: "https://cdn1.infocasas.com.uy/web/SA.png",
	},
	{
		code: "DZ",
		label: "Argelia",
		phone: "213",
		icon: "https://cdn1.infocasas.com.uy/web/DZ.png",
	},
	{
		code: "AM",
		label: "Armenia",
		phone: "374",
		icon: "https://cdn1.infocasas.com.uy/web/AM.png",
	},
	{ code: "AW", label: "Aruba", phone: "297", icon: "https://cdn1.infocasas.com.uy/web/AW.png" },
	{
		code: "AU",
		label: "Australia",
		phone: "61",
		icon: "https://cdn1.infocasas.com.uy/web/AU.png",
	},
	{ code: "AT", label: "Austria", phone: "43", icon: "https://cdn1.infocasas.com.uy/web/AT.png" },
	{
		code: "AZ",
		label: "Azerbaiyán",
		phone: "994",
		icon: "https://cdn1.infocasas.com.uy/web/AZ.png",
	},
	{ code: "BE", label: "Bélgica", phone: "32", icon: "https://cdn1.infocasas.com.uy/web/BE.png" },
	{
		code: "BS",
		label: "Bahamas",
		phone: "1242",
		icon: "https://cdn1.infocasas.com.uy/web/BS.png",
	},
	{
		code: "BH",
		label: "Bahrein",
		phone: "973",
		icon: "https://cdn1.infocasas.com.uy/web/BH.png",
	},
	{
		code: "BD",
		label: "Bangladesh",
		phone: "880",
		icon: "https://cdn1.infocasas.com.uy/web/BD.png",
	},
	{
		code: "BB",
		label: "Barbados",
		phone: "1246",
		icon: "https://cdn1.infocasas.com.uy/web/BB.png",
	},
	{ code: "BZ", label: "Belice", phone: "501", icon: "https://cdn1.infocasas.com.uy/web/BZ.png" },
	{ code: "BJ", label: "Benín", phone: "229", icon: "https://cdn1.infocasas.com.uy/web/BJ.png" },
	{ code: "BT", label: "Bhután", phone: "975", icon: "https://cdn1.infocasas.com.uy/web/BT.png" },
	{
		code: "BY",
		label: "Bielorrusia",
		phone: "375",
		icon: "https://cdn1.infocasas.com.uy/web/BY.png",
	},
	{
		code: "MM",
		label: "Birmania",
		phone: "95",
		icon: "https://cdn1.infocasas.com.uy/web/MM.png",
	},
	{
		code: "BA",
		label: "Bosnia y Herzegovina",
		phone: "387",
		icon: "https://cdn1.infocasas.com.uy/web/BA.png",
	},
	{
		code: "BW",
		label: "Botsuana",
		phone: "267",
		icon: "https://cdn1.infocasas.com.uy/web/BW.png",
	},
	{ code: "BN", label: "Brunéi", phone: "673", icon: "https://cdn1.infocasas.com.uy/web/BN.png" },
	{
		code: "BG",
		label: "Bulgaria",
		phone: "359",
		icon: "https://cdn1.infocasas.com.uy/web/BG.png",
	},
	{
		code: "BF",
		label: "Burkina Faso",
		phone: "226",
		icon: "https://cdn1.infocasas.com.uy/web/BF.png",
	},
	{
		code: "BI",
		label: "Burundi",
		phone: "257",
		icon: "https://cdn1.infocasas.com.uy/web/BI.png",
	},
	{
		code: "CV",
		label: "Cabo Verde",
		phone: "238",
		icon: "https://cdn1.infocasas.com.uy/web/CV.png",
	},
	{
		code: "KH",
		label: "Camboya",
		phone: "855",
		icon: "https://cdn1.infocasas.com.uy/web/KH.png",
	},
	{
		code: "CM",
		label: "Camerún",
		phone: "237",
		icon: "https://cdn1.infocasas.com.uy/web/CM.png",
	},
	{ code: "CA", label: "Canadá", phone: "1", icon: "https://cdn1.infocasas.com.uy/web/CA.png" },
	{ code: "TD", label: "Chad", phone: "235", icon: "https://cdn1.infocasas.com.uy/web/TD.png" },
	{ code: "CN", label: "China", phone: "86", icon: "https://cdn1.infocasas.com.uy/web/CN.png" },
	{ code: "CY", label: "Chipre", phone: "357", icon: "https://cdn1.infocasas.com.uy/web/CY.png" },
	{
		code: "VA",
		label: "Ciudad del Vaticano",
		phone: "39",
		icon: "https://cdn1.infocasas.com.uy/web/VA.png",
	},
	{
		code: "KM",
		label: "Comoras",
		phone: "269",
		icon: "https://cdn1.infocasas.com.uy/web/KM.png",
	},
	{
		code: "CG",
		label: "República del Congo",
		phone: "242",
		icon: "https://cdn1.infocasas.com.uy/web/CG.png",
	},
	{
		code: "CD",
		label: "República Democrática del Congo",
		phone: "243",
		icon: "https://cdn1.infocasas.com.uy/web/CD.png",
	},
	{
		code: "KP",
		label: "Corea del Norte",
		phone: "850",
		icon: "https://cdn1.infocasas.com.uy/web/KP.png",
	},
	{
		code: "KR",
		label: "Corea del Sur",
		phone: "82",
		icon: "https://cdn1.infocasas.com.uy/web/KR.png",
	},
	{
		code: "CI",
		label: "Costa de Marfil",
		phone: "225",
		icon: "https://cdn1.infocasas.com.uy/web/CI.png",
	},
	{
		code: "CR",
		label: "Costa Rica",
		phone: "506",
		icon: "https://cdn1.infocasas.com.uy/web/CR.png",
	},
	{
		code: "HR",
		label: "Croacia",
		phone: "385",
		icon: "https://cdn1.infocasas.com.uy/web/HR.png",
	},
	{ code: "CU", label: "Cuba", phone: "53", icon: "https://cdn1.infocasas.com.uy/web/CU.png" },
	{
		code: "CW",
		label: "Curazao",
		phone: "5999",
		icon: "https://cdn1.infocasas.com.uy/web/CW.png",
	},
	{
		code: "DK",
		label: "Dinamarca",
		phone: "45",
		icon: "https://cdn1.infocasas.com.uy/web/DK.png",
	},
	{
		code: "DM",
		label: "Dominica",
		phone: "1767",
		icon: "https://cdn1.infocasas.com.uy/web/DM.png",
	},
	{ code: "EG", label: "Egipto", phone: "20", icon: "https://cdn1.infocasas.com.uy/web/EG.png" },
	{
		code: "SV",
		label: "El Salvador",
		phone: "503",
		icon: "https://cdn1.infocasas.com.uy/web/SV.png",
	},
	{
		code: "AE",
		label: "Emiratos Árabes Unidos",
		phone: "971",
		icon: "https://cdn1.infocasas.com.uy/web/AE.png",
	},
	{
		code: "ER",
		label: "Eritrea",
		phone: "291",
		icon: "https://cdn1.infocasas.com.uy/web/ER.png",
	},
	{
		code: "SK",
		label: "Eslovaquia",
		phone: "421",
		icon: "https://cdn1.infocasas.com.uy/web/SK.png",
	},
	{
		code: "SI",
		label: "Eslovenia",
		phone: "386",
		icon: "https://cdn1.infocasas.com.uy/web/SI.png",
	},
	{ code: "ES", label: "España", phone: "34", icon: "https://cdn1.infocasas.com.uy/web/ES.png" },
	{
		code: "EE",
		label: "Estonia",
		phone: "372",
		icon: "https://cdn1.infocasas.com.uy/web/EE.png",
	},
	{
		code: "ET",
		label: "Etiopía",
		phone: "251",
		icon: "https://cdn1.infocasas.com.uy/web/ET.png",
	},
	{
		code: "PH",
		label: "Filipinas",
		phone: "63",
		icon: "https://cdn1.infocasas.com.uy/web/PH.png",
	},
	{
		code: "FI",
		label: "Finlandia",
		phone: "358",
		icon: "https://cdn1.infocasas.com.uy/web/FI.png",
	},
	{ code: "FJ", label: "Fiyi", phone: "679", icon: "https://cdn1.infocasas.com.uy/web/FJ.png" },
	{ code: "FR", label: "Francia", phone: "33", icon: "https://cdn1.infocasas.com.uy/web/FR.png" },
	{ code: "GA", label: "Gabón", phone: "241", icon: "https://cdn1.infocasas.com.uy/web/GA.png" },
	{ code: "GM", label: "Gambia", phone: "220", icon: "https://cdn1.infocasas.com.uy/web/GM.png" },
	{
		code: "GE",
		label: "Georgia",
		phone: "995",
		icon: "https://cdn1.infocasas.com.uy/web/GE.png",
	},
	{ code: "GH", label: "Ghana", phone: "233", icon: "https://cdn1.infocasas.com.uy/web/GH.png" },
	{
		code: "GI",
		label: "Gibraltar",
		phone: "350",
		icon: "https://cdn1.infocasas.com.uy/web/GI.png",
	},
	{
		code: "GD",
		label: "Granada",
		phone: "1473",
		icon: "https://cdn1.infocasas.com.uy/web/GD.png",
	},
	{ code: "GR", label: "Grecia", phone: "30", icon: "https://cdn1.infocasas.com.uy/web/GR.png" },
	{
		code: "GL",
		label: "Groenlandia",
		phone: "299",
		icon: "https://cdn1.infocasas.com.uy/web/GL.png",
	},
	{
		code: "GP",
		label: "Guadalupe",
		phone: "590",
		icon: "https://cdn1.infocasas.com.uy/web/GP.png",
	},
	{ code: "GU", label: "Guam", phone: "1671", icon: "https://cdn1.infocasas.com.uy/web/GU.png" },
	{
		code: "GT",
		label: "Guatemala",
		phone: "502",
		icon: "https://cdn1.infocasas.com.uy/web/GT.png",
	},
	{
		code: "GF",
		label: "Guayana Francesa",
		phone: "594",
		icon: "https://cdn1.infocasas.com.uy/web/GF.png",
	},
	{
		code: "GG",
		label: "Guernsey",
		phone: "44",
		icon: "https://cdn1.infocasas.com.uy/web/GG.png",
	},
	{ code: "GN", label: "Guinea", phone: "224", icon: "https://cdn1.infocasas.com.uy/web/GN.png" },
	{
		code: "GQ",
		label: "Guinea Ecuatorial",
		phone: "240",
		icon: "https://cdn1.infocasas.com.uy/web/GQ.png",
	},
	{
		code: "GW",
		label: "Guinea-Bissau",
		phone: "245",
		icon: "https://cdn1.infocasas.com.uy/web/GW.png",
	},
	{ code: "HT", label: "Haití", phone: "509", icon: "https://cdn1.infocasas.com.uy/web/HT.png" },
	{
		code: "HN",
		label: "Honduras",
		phone: "504",
		icon: "https://cdn1.infocasas.com.uy/web/HN.png",
	},
	{
		code: "HK",
		label: "Hong kong",
		phone: "852",
		icon: "https://cdn1.infocasas.com.uy/web/HK.png",
	},
	{ code: "HU", label: "Hungría", phone: "36", icon: "https://cdn1.infocasas.com.uy/web/HU.png" },
	{ code: "IN", label: "India", phone: "91", icon: "https://cdn1.infocasas.com.uy/web/IN.png" },
	{
		code: "ID",
		label: "Indonesia",
		phone: "62",
		icon: "https://cdn1.infocasas.com.uy/web/ID.png",
	},
	{ code: "IR", label: "Irán", phone: "98", icon: "https://cdn1.infocasas.com.uy/web/IR.png" },
	{ code: "IQ", label: "Irak", phone: "964", icon: "https://cdn1.infocasas.com.uy/web/IQ.png" },
	{
		code: "IE",
		label: "Irlanda",
		phone: "353",
		icon: "https://cdn1.infocasas.com.uy/web/IE.png",
	},
	{
		code: "IM",
		label: "Isla de Man",
		phone: "44",
		icon: "https://cdn1.infocasas.com.uy/web/IM.png",
	},
	{
		code: "CX",
		label: "Isla de Navidad",
		phone: "61",
		icon: "https://cdn1.infocasas.com.uy/web/CX.png",
	},
	{
		code: "NF",
		label: "Isla Norfolk",
		phone: "672",
		icon: "https://cdn1.infocasas.com.uy/web/NF.png",
	},
	{
		code: "IS",
		label: "Islandia",
		phone: "354",
		icon: "https://cdn1.infocasas.com.uy/web/IS.png",
	},
	{
		code: "BM",
		label: "Islas Bermudas",
		phone: "1441",
		icon: "https://cdn1.infocasas.com.uy/web/BM.png",
	},
	{
		code: "KY",
		label: "Islas Caimán",
		phone: "1345",
		icon: "https://cdn1.infocasas.com.uy/web/KY.png",
	},
	{
		code: "CC",
		label: "Islas Cocos (Keeling)",
		phone: "61",
		icon: "https://cdn1.infocasas.com.uy/web/CC.png",
	},
	{
		code: "CK",
		label: "Islas Cook",
		phone: "682",
		icon: "https://cdn1.infocasas.com.uy/web/CK.png",
	},
	{
		code: "AX",
		label: "Islas de Åland",
		phone: "358",
		icon: "https://cdn1.infocasas.com.uy/web/AX.png",
	},
	{
		code: "FO",
		label: "Islas Feroe",
		phone: "298",
		icon: "https://cdn1.infocasas.com.uy/web/FO.png",
	},
	{
		code: "MV",
		label: "Islas Maldivas",
		phone: "960",
		icon: "https://cdn1.infocasas.com.uy/web/MV.png",
	},
	{
		code: "FK",
		label: "Islas Malvinas",
		phone: "500",
		icon: "https://cdn1.infocasas.com.uy/web/AR.png",
	},
	{
		code: "MP",
		label: "Islas Marianas del Norte",
		phone: "1670",
		icon: "https://cdn1.infocasas.com.uy/web/MP.png",
	},
	{
		code: "MH",
		label: "Islas Marshall",
		phone: "692",
		icon: "https://cdn1.infocasas.com.uy/web/MH.png",
	},
	{
		code: "PN",
		label: "Islas Pitcairn",
		phone: "870",
		icon: "https://cdn1.infocasas.com.uy/web/PN.png",
	},
	{
		code: "SB",
		label: "Islas Salomón",
		phone: "677",
		icon: "https://cdn1.infocasas.com.uy/web/SB.png",
	},
	{
		code: "TC",
		label: "Islas Turcas y Caicos",
		phone: "1649",
		icon: "https://cdn1.infocasas.com.uy/web/TC.png",
	},
	{
		code: "VG",
		label: "Islas Vírgenes Británicas",
		phone: "1284",
		icon: "https://cdn1.infocasas.com.uy/web/VG.png",
	},
	{
		code: "VI",
		label: "Islas Vírgenes de los Estados Unidos",
		phone: "1340",
		icon: "https://cdn1.infocasas.com.uy/web/VI.png",
	},
	{ code: "IL", label: "Israel", phone: "972", icon: "https://cdn1.infocasas.com.uy/web/IL.png" },
	{ code: "IT", label: "Italia", phone: "39", icon: "https://cdn1.infocasas.com.uy/web/IT.png" },
	{
		code: "JM",
		label: "Jamaica",
		phone: "1876",
		icon: "https://cdn1.infocasas.com.uy/web/JM.png",
	},
	{ code: "JP", label: "Japón", phone: "81", icon: "https://cdn1.infocasas.com.uy/web/JP.png" },
	{ code: "JE", label: "Jersey", phone: "44", icon: "https://cdn1.infocasas.com.uy/web/JE.png" },
	{
		code: "JO",
		label: "Jordania",
		phone: "962",
		icon: "https://cdn1.infocasas.com.uy/web/JO.png",
	},
	{
		code: "KZ",
		label: "Kazajistán",
		phone: "7",
		icon: "https://cdn1.infocasas.com.uy/web/KZ.png",
	},
	{ code: "KE", label: "Kenia", phone: "254", icon: "https://cdn1.infocasas.com.uy/web/KE.png" },
	{
		code: "KG",
		label: "Kirguistán",
		phone: "996",
		icon: "https://cdn1.infocasas.com.uy/web/KG.png",
	},
	{
		code: "KI",
		label: "Kiribati",
		phone: "686",
		icon: "https://cdn1.infocasas.com.uy/web/KI.png",
	},
	{ code: "KW", label: "Kuwait", phone: "965", icon: "https://cdn1.infocasas.com.uy/web/KW.png" },
	{ code: "LB", label: "Líbano", phone: "961", icon: "https://cdn1.infocasas.com.uy/web/LB.png" },
	{ code: "LA", label: "Laos", phone: "856", icon: "https://cdn1.infocasas.com.uy/web/LA.png" },
	{ code: "LS", label: "Lesoto", phone: "266", icon: "https://cdn1.infocasas.com.uy/web/LS.png" },
	{
		code: "LV",
		label: "Letonia",
		phone: "371",
		icon: "https://cdn1.infocasas.com.uy/web/LV.png",
	},
	{
		code: "LR",
		label: "Liberia",
		phone: "231",
		icon: "https://cdn1.infocasas.com.uy/web/LR.png",
	},
	{ code: "LY", label: "Libia", phone: "218", icon: "https://cdn1.infocasas.com.uy/web/LY.png" },
	{
		code: "LI",
		label: "Liechtenstein",
		phone: "423",
		icon: "https://cdn1.infocasas.com.uy/web/LI.png",
	},
	{
		code: "LT",
		label: "Lituania",
		phone: "370",
		icon: "https://cdn1.infocasas.com.uy/web/LT.png",
	},
	{
		code: "LU",
		label: "Luxemburgo",
		phone: "352",
		icon: "https://cdn1.infocasas.com.uy/web/LU.png",
	},
	{ code: "MX", label: "México", phone: "52", icon: "https://cdn1.infocasas.com.uy/web/MX.png" },
	{ code: "MC", label: "Mónaco", phone: "377", icon: "https://cdn1.infocasas.com.uy/web/MC.png" },
	{ code: "MO", label: "Macao", phone: "853", icon: "https://cdn1.infocasas.com.uy/web/MO.png" },
	{
		code: "MK",
		label: "Macedônia",
		phone: "389",
		icon: "https://cdn1.infocasas.com.uy/web/MK.png",
	},
	{
		code: "MG",
		label: "Madagascar",
		phone: "261",
		icon: "https://cdn1.infocasas.com.uy/web/MG.png",
	},
	{ code: "MY", label: "Malasia", phone: "60", icon: "https://cdn1.infocasas.com.uy/web/MY.png" },
	{ code: "MW", label: "Malawi", phone: "265", icon: "https://cdn1.infocasas.com.uy/web/MW.png" },
	{ code: "ML", label: "Mali", phone: "223", icon: "https://cdn1.infocasas.com.uy/web/ML.png" },
	{ code: "MT", label: "Malta", phone: "356", icon: "https://cdn1.infocasas.com.uy/web/MT.png" },
	{
		code: "MA",
		label: "Marruecos",
		phone: "212",
		icon: "https://cdn1.infocasas.com.uy/web/MA.png",
	},
	{
		code: "MQ",
		label: "Martinica",
		phone: "596",
		icon: "https://cdn1.infocasas.com.uy/web/MQ.png",
	},
	{
		code: "MU",
		label: "Mauricio",
		phone: "230",
		icon: "https://cdn1.infocasas.com.uy/web/MU.png",
	},
	{
		code: "MR",
		label: "Mauritania",
		phone: "222",
		icon: "https://cdn1.infocasas.com.uy/web/MR.png",
	},
	{
		code: "YT",
		label: "Mayotte",
		phone: "262",
		icon: "https://cdn1.infocasas.com.uy/web/YT.png",
	},
	{
		code: "FM",
		label: "Micronesia",
		phone: "691",
		icon: "https://cdn1.infocasas.com.uy/web/FM.png",
	},
	{
		code: "MD",
		label: "Moldavia",
		phone: "373",
		icon: "https://cdn1.infocasas.com.uy/web/MD.png",
	},
	{
		code: "MN",
		label: "Mongolia",
		phone: "976",
		icon: "https://cdn1.infocasas.com.uy/web/MN.png",
	},
	{
		code: "ME",
		label: "Montenegro",
		phone: "382",
		icon: "https://cdn1.infocasas.com.uy/web/ME.png",
	},
	{
		code: "MS",
		label: "Montserrat",
		phone: "1664",
		icon: "https://cdn1.infocasas.com.uy/web/MS.png",
	},
	{
		code: "MZ",
		label: "Mozambique",
		phone: "258",
		icon: "https://cdn1.infocasas.com.uy/web/MZ.png",
	},
	{
		code: "NA",
		label: "Namibia",
		phone: "264",
		icon: "https://cdn1.infocasas.com.uy/web/NA.png",
	},
	{ code: "NR", label: "Nauru", phone: "674", icon: "https://cdn1.infocasas.com.uy/web/NR.png" },
	{ code: "NP", label: "Nepal", phone: "977", icon: "https://cdn1.infocasas.com.uy/web/NP.png" },
	{
		code: "NI",
		label: "Nicaragua",
		phone: "505",
		icon: "https://cdn1.infocasas.com.uy/web/NI.png",
	},
	{ code: "NE", label: "Niger", phone: "227", icon: "https://cdn1.infocasas.com.uy/web/NE.png" },
	{
		code: "NG",
		label: "Nigeria",
		phone: "234",
		icon: "https://cdn1.infocasas.com.uy/web/NG.png",
	},
	{ code: "NU", label: "Niue", phone: "683", icon: "https://cdn1.infocasas.com.uy/web/NU.png" },
	{ code: "NO", label: "Noruega", phone: "47", icon: "https://cdn1.infocasas.com.uy/web/NO.png" },
	{
		code: "NC",
		label: "Nueva Caledonia",
		phone: "687",
		icon: "https://cdn1.infocasas.com.uy/web/NC.png",
	},
	{
		code: "NZ",
		label: "Nueva Zelanda",
		phone: "64",
		icon: "https://cdn1.infocasas.com.uy/web/NZ.png",
	},
	{ code: "OM", label: "Omán", phone: "968", icon: "https://cdn1.infocasas.com.uy/web/OM.png" },
	{
		code: "NL",
		label: "Países Bajos",
		phone: "31",
		icon: "https://cdn1.infocasas.com.uy/web/NL.png",
	},
	{
		code: "PK",
		label: "Pakistán",
		phone: "92",
		icon: "https://cdn1.infocasas.com.uy/web/PK.png",
	},
	{ code: "PW", label: "Palau", phone: "680", icon: "https://cdn1.infocasas.com.uy/web/PW.png" },
	{
		code: "PS",
		label: "Palestina",
		phone: "970",
		icon: "https://cdn1.infocasas.com.uy/web/PS.png",
	},
	{ code: "PA", label: "Panamá", phone: "507", icon: "https://cdn1.infocasas.com.uy/web/PA.png" },
	{
		code: "PG",
		label: "Papúa Nueva Guinea",
		phone: "675",
		icon: "https://cdn1.infocasas.com.uy/web/PG.png",
	},
	{
		code: "PF",
		label: "Polinesia Francesa",
		phone: "689",
		icon: "https://cdn1.infocasas.com.uy/web/PF.png",
	},
	{ code: "PL", label: "Polonia", phone: "48", icon: "https://cdn1.infocasas.com.uy/web/PL.png" },
	{
		code: "PT",
		label: "Portugal",
		phone: "351",
		icon: "https://cdn1.infocasas.com.uy/web/PT.png",
	},
	{
		code: "PR",
		label: "Puerto Rico",
		phone: "1",
		icon: "https://cdn1.infocasas.com.uy/web/PR.png",
	},
	{ code: "QA", label: "Qatar", phone: "974", icon: "https://cdn1.infocasas.com.uy/web/QA.png" },
	{
		code: "GB",
		label: "Reino Unido",
		phone: "44",
		icon: "https://cdn1.infocasas.com.uy/web/GB.png",
	},
	{
		code: "CF",
		label: "República Centroafricana",
		phone: "236",
		icon: "https://cdn1.infocasas.com.uy/web/CF.png",
	},
	{
		code: "CZ",
		label: "República Checa",
		phone: "420",
		icon: "https://cdn1.infocasas.com.uy/web/CZ.png",
	},
	{
		code: "DO",
		label: "República Dominicana",
		phone: "1809",
		icon: "https://cdn1.infocasas.com.uy/web/DO.png",
	},
	{
		code: "SS",
		label: "República de Sudán del Sur",
		phone: "211",
		icon: "https://cdn1.infocasas.com.uy/web/SS.png",
	},
	{
		code: "RE",
		label: "Reunión",
		phone: "262",
		icon: "https://cdn1.infocasas.com.uy/web/RE.png",
	},
	{ code: "RW", label: "Ruanda", phone: "250", icon: "https://cdn1.infocasas.com.uy/web/RW.png" },
	{ code: "RO", label: "Rumanía", phone: "40", icon: "https://cdn1.infocasas.com.uy/web/RO.png" },
	{ code: "RU", label: "Rusia", phone: "7", icon: "https://cdn1.infocasas.com.uy/web/RU.png" },
	{
		code: "EH",
		label: "Sahara Occidental",
		phone: "212",
		icon: "https://cdn1.infocasas.com.uy/web/EH.png",
	},
	{ code: "WS", label: "Samoa", phone: "685", icon: "https://cdn1.infocasas.com.uy/web/WS.png" },
	{
		code: "AS",
		label: "Samoa Americana",
		phone: "1684",
		icon: "https://cdn1.infocasas.com.uy/web/AS.png",
	},
	{
		code: "BL",
		label: "San Bartolomé",
		phone: "590",
		icon: "https://cdn1.infocasas.com.uy/web/BL.png",
	},
	{
		code: "KN",
		label: "San Cristóbal y Nieves",
		phone: "1869",
		icon: "https://cdn1.infocasas.com.uy/web/KN.png",
	},
	{
		code: "SM",
		label: "San Marino",
		phone: "378",
		icon: "https://cdn1.infocasas.com.uy/web/SM.png",
	},
	{
		code: "MF",
		label: "San Martín (Francia)",
		phone: "1599",
		icon: "https://cdn1.infocasas.com.uy/web/MF.png",
	},
	{
		code: "PM",
		label: "San Pedro y Miquelón",
		phone: "508",
		icon: "https://cdn1.infocasas.com.uy/web/PM.png",
	},
	{
		code: "VC",
		label: "San Vicente y las Granadinas",
		phone: "1784",
		icon: "https://cdn1.infocasas.com.uy/web/VC.png",
	},
	{
		code: "SH",
		label: "Santa Elena",
		phone: "290",
		icon: "https://cdn1.infocasas.com.uy/web/SH.png",
	},
	{
		code: "LC",
		label: "Santa Lucía",
		phone: "1758",
		icon: "https://cdn1.infocasas.com.uy/web/LC.png",
	},
	{
		code: "ST",
		label: "Santo Tomé y Príncipe",
		phone: "239",
		icon: "https://cdn1.infocasas.com.uy/web/ST.png",
	},
	{
		code: "SN",
		label: "Senegal",
		phone: "221",
		icon: "https://cdn1.infocasas.com.uy/web/SN.png",
	},
	{ code: "RS", label: "Serbia", phone: "381", icon: "https://cdn1.infocasas.com.uy/web/RS.png" },
	{
		code: "SC",
		label: "Seychelles",
		phone: "248",
		icon: "https://cdn1.infocasas.com.uy/web/SC.png",
	},
	{
		code: "SL",
		label: "Sierra Leona",
		phone: "232",
		icon: "https://cdn1.infocasas.com.uy/web/SL.png",
	},
	{
		code: "SG",
		label: "Singapur",
		phone: "65",
		icon: "https://cdn1.infocasas.com.uy/web/SG.png",
	},
	{
		code: "SX",
		label: "Sint Maarten",
		phone: "1721",
		icon: "https://cdn1.infocasas.com.uy/web/SX.png",
	},
	{ code: "SY", label: "Siria", phone: "963", icon: "https://cdn1.infocasas.com.uy/web/SY.png" },
	{
		code: "SO",
		label: "Somalia",
		phone: "252",
		icon: "https://cdn1.infocasas.com.uy/web/SO.png",
	},
	{
		code: "LK",
		label: "Sri lanka",
		phone: "94",
		icon: "https://cdn1.infocasas.com.uy/web/LK.png",
	},
	{
		code: "ZA",
		label: "Sudáfrica",
		phone: "27",
		icon: "https://cdn1.infocasas.com.uy/web/ZA.png",
	},
	{ code: "SD", label: "Sudán", phone: "249", icon: "https://cdn1.infocasas.com.uy/web/SD.png" },
	{ code: "SE", label: "Suecia", phone: "46", icon: "https://cdn1.infocasas.com.uy/web/SE.png" },
	{ code: "CH", label: "Suiza", phone: "41", icon: "https://cdn1.infocasas.com.uy/web/CH.png" },
	{
		code: "SR",
		label: "Surinám",
		phone: "597",
		icon: "https://cdn1.infocasas.com.uy/web/SR.png",
	},
	{
		code: "SJ",
		label: "Svalbard y Jan Mayen",
		phone: "47",
		icon: "https://cdn1.infocasas.com.uy/web/SJ.png",
	},
	{
		code: "SZ",
		label: "Swazilandia",
		phone: "268",
		icon: "https://cdn1.infocasas.com.uy/web/SZ.png",
	},
	{
		code: "TJ",
		label: "Tayikistán",
		phone: "992",
		icon: "https://cdn1.infocasas.com.uy/web/TJ.png",
	},
	{
		code: "TH",
		label: "Tailandia",
		phone: "66",
		icon: "https://cdn1.infocasas.com.uy/web/TH.png",
	},
	{
		code: "TZ",
		label: "Tanzania",
		phone: "255",
		icon: "https://cdn1.infocasas.com.uy/web/TZ.png",
	},
	{
		code: "IO",
		label: "Territorio Británico del Océano Índico",
		phone: "246",
		icon: "https://cdn1.infocasas.com.uy/web/IO.png",
	},
	{
		code: "TL",
		label: "Timor Oriental",
		phone: "670",
		icon: "https://cdn1.infocasas.com.uy/web/TL.png",
	},
	{ code: "TG", label: "Togo", phone: "228", icon: "https://cdn1.infocasas.com.uy/web/TG.png" },
	{
		code: "TK",
		label: "Tokelau",
		phone: "690",
		icon: "https://cdn1.infocasas.com.uy/web/TK.png",
	},
	{ code: "TO", label: "Tonga", phone: "676", icon: "https://cdn1.infocasas.com.uy/web/TO.png" },
	{
		code: "TT",
		label: "Trinidad y Tobago",
		phone: "1868",
		icon: "https://cdn1.infocasas.com.uy/web/TT.png",
	},
	{ code: "TN", label: "Tunez", phone: "216", icon: "https://cdn1.infocasas.com.uy/web/TN.png" },
	{
		code: "TM",
		label: "Turkmenistán",
		phone: "993",
		icon: "https://cdn1.infocasas.com.uy/web/TM.png",
	},
	{ code: "TR", label: "Turquía", phone: "90", icon: "https://cdn1.infocasas.com.uy/web/TR.png" },
	{ code: "TV", label: "Tuvalu", phone: "688", icon: "https://cdn1.infocasas.com.uy/web/TV.png" },
	{
		code: "UA",
		label: "Ucrania",
		phone: "380",
		icon: "https://cdn1.infocasas.com.uy/web/UA.png",
	},
	{ code: "UG", label: "Uganda", phone: "256", icon: "https://cdn1.infocasas.com.uy/web/UG.png" },
	{
		code: "UZ",
		label: "Uzbekistán",
		phone: "998",
		icon: "https://cdn1.infocasas.com.uy/web/UZ.png",
	},
	{
		code: "VU",
		label: "Vanuatu",
		phone: "678",
		icon: "https://cdn1.infocasas.com.uy/web/VU.png",
	},
	{ code: "VN", label: "Vietnam", phone: "84", icon: "https://cdn1.infocasas.com.uy/web/VN.png" },
	{
		code: "WF",
		label: "Wallis y Futuna",
		phone: "681",
		icon: "https://cdn1.infocasas.com.uy/web/WF.png",
	},
	{ code: "YE", label: "Yemen", phone: "967", icon: "https://cdn1.infocasas.com.uy/web/YE.png" },
	{ code: "DJ", label: "Yibuti", phone: "253", icon: "https://cdn1.infocasas.com.uy/web/DJ.png" },
	{ code: "ZM", label: "Zambia", phone: "260", icon: "https://cdn1.infocasas.com.uy/web/ZM.png" },
	{
		code: "ZW",
		label: "Zimbabue",
		phone: "263",
		icon: "https://cdn1.infocasas.com.uy/web/ZW.png",
	},
];
export default countries;

